import { useGraphAnnotationStore } from 'store/graphAnnotation.store';
import { useThemeStatusStore } from 'store/themeStatus.store';
import { getPoints, serializeData, serializeOptions } from 'components/widgets/SCurve/Scurve.utils';

import { ProgressMeasurement } from 'components/common/GlobalFilterComponent/components/progressMeasurementFilter/progressMeasurementFilter';

const FILTER_LIST: ProgressMeasurement[] = [
    'activityCompleted',
    'activityCompletedCriticality',
    'activitySubmittedCompletion',
    'activitySubmittedCompletionCriticality',
];

export const useScurveLogic = ({ ui, api }) => {
    const { data, isFetching } = api.scurveGraph;
    const sourceData = ui.state;
    const isShowCriticalityAnnotation = useGraphAnnotationStore((store) => store.isShowCriticalityAnnotation);
    const { update } = useGraphAnnotationStore();
    const { themeStatus } = useThemeStatusStore();
    const pointsAnnotation = getPoints(data);
    const series = serializeData(data);
    const options = serializeOptions({
        series,
        nowDate: data?.nowDate,
        themeStatus,
        isShowAnnotation: isShowCriticalityAnnotation,
        pointsAnnotation,
    });

    const noResults =
        !isFetching && data?.plannedGraphLine?.data?.length === 0 && data?.actualGraphLine?.data?.length === 0;

    const notApplicable =
        FILTER_LIST.includes(sourceData?.progressMeasurement) &&
        Boolean(sourceData?.resourceType || sourceData?.resource);

    const noDataCondition = noResults || notApplicable;
    return { noDataCondition, options, update, isShowCriticalityAnnotation, series, notApplicable };
};
